import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { TX_DATA_TAGS as E, TX_DATA_AMOUNT as p, TX_DATA_PAY_METHOD as h, TX_DATA_PAY_METHOD_LOGO_CONTAINER as v, TX_DATA_PAY_METHOD_LOGO as M, TX_DATA_PAY_METHOD_DETAIL as N, TX_DATA_LABEL as O } from "../constants.js";
import { getPaymentMethodTypeForTransaction as S, getDisplayablePaymentMethodForTransaction as F, getRefundTypeForTransaction as C, getAmountStyleForTransaction as P } from "../utils.js";
import R from "classnames";
import { memo as U } from "../../../../../external/preact/compat/dist/compat.module.js";
import { useMemo as u } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import b from "../../../../../core/Context/useCoreContext.js";
import x from "../../../../../hooks/useTimezoneAwareDateFormatting.js";
import { RefundType as _, RefundedState as f } from "../../context/types.js";
import { Image as I } from "../../../../internal/Image/Image.js";
import { TagVariant as a } from "../../../../internal/Tag/types.js";
import { Tag as o } from "../../../../internal/Tag/Tag.js";
import { Fragment as D } from "../../../../../external/preact/dist/preact.module.js";
import { DATE_FORMAT_TRANSACTION_DETAILS as X } from "../../../../../constants/dateFormats.js";
const $ = ({ refundedState: n, transaction: r }) => {
  var s;
  const { i18n: t } = b(), { dateFormat: g } = x((s = r == null ? void 0 : r.balanceAccount) == null ? void 0 : s.timeZone), {
    amount: l,
    category: i,
    createdAt: A
    /*, status*/
  } = r, d = u(() => {
    const { currency: c, value: L } = l;
    return `${t.amount(L, c, { hideCurrency: !0 })} ${c}`;
  }, [l, t]), [m, y, T] = u(
    () => [
      S(r),
      F(r),
      C(r)
    ],
    [r]
  );
  return /* @__PURE__ */ e(D, { children: [
    /* @__PURE__ */ e("div", { className: E, children: [
      i && /* @__PURE__ */ e(o, { label: t.get(`txType.${i}`), variant: a.DEFAULT }),
      T && /* @__PURE__ */ e(D, { children: [
        T === _.FULL && /* @__PURE__ */ e(o, { label: t.get("full"), variant: a.SUCCESS }),
        T === _.PARTIAL && /* @__PURE__ */ e(o, { label: t.get("partial"), variant: a.BLUE })
      ] }),
      n === f.FULL && /* @__PURE__ */ e(o, { label: t.get("refunded.full"), variant: a.SUCCESS }),
      n === f.PARTIAL && /* @__PURE__ */ e(o, { label: t.get("refunded.partial"), variant: a.BLUE })
    ] }),
    d && /* @__PURE__ */ e("div", { className: R(p, `${p}--${P(r)}`), children: d }),
    m && /* @__PURE__ */ e("div", { className: h, children: [
      /* @__PURE__ */ e("div", { className: v, children: /* @__PURE__ */ e(I, { className: M, name: m, alt: m, folder: "logos/" }) }),
      /* @__PURE__ */ e("div", { className: N, children: y })
    ] }),
    A && /* @__PURE__ */ e("div", { className: O, children: g(new Date(A), X) })
  ] });
}, W = U($);
export {
  W as default
};
